/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated hooks metrics for a single server
 */
export type HooksServerSummary = {
  /**
   * Total number of hook events for this server
   */
  eventCount: number;
  /**
   * Number of failed tool completions (PostToolUseFailure events)
   */
  failureCount: number;
  /**
   * Failure rate as a decimal (0.0 to 1.0)
   */
  failureRate: number;
  /**
   * Server name (extracted from tool name, or 'local' for non-MCP tools)
   */
  serverName: string;
  /**
   * Number of successful tool completions (PostToolUse events)
   */
  successCount: number;
  /**
   * Number of unique tools used for this server
   */
  uniqueTools: number;
};

/** @internal */
export const HooksServerSummary$inboundSchema: z.ZodMiniType<
  HooksServerSummary,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    server_name: z.string(),
    success_count: z.int(),
    unique_tools: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "server_name": "serverName",
      "success_count": "successCount",
      "unique_tools": "uniqueTools",
    });
  }),
);

export function hooksServerSummaryFromJSON(
  jsonString: string,
): SafeParseResult<HooksServerSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HooksServerSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HooksServerSummary' from JSON`,
  );
}
